// UX PHILOSOPHY:

import type { KeyboardEvent } from 'react';

// Learn once - use everywhere
export const HOTKEYS: Record<string, string | [string, string]> = {
  // Global
  GLOBAL_GO_TO_INBOX: ['g', 'i'],
  GLOBAL_GO_TO_DEALS: ['g', 'd'],
  GLOBAL_GO_TO_APPRAISALS: ['g', 'p'],
  GLOBAL_GO_TO_ARCHIVED_DEALS: ['g', 'o'],
  GLOBAL_GO_TO_MY_DEALS: ['g', 'm'],
  GLOBAL_GO_TO_MY_TASKS: ['g', 'k'],
  GLOBAL_GO_TO_ALL_TASKS: ['g', 'u'],
  GLOBAL_GO_TO_DELIVERY_QUEUE: ['g', 'q'],
  GLOBAL_GO_TO_LOG_BOOK: ['g', 'b'],
  GLOBAL_GO_TO_CONTRACT_STATUS: ['g', 'c'],
  GLOBAL_GO_TO_TRADES: ['g', 't'],
  GLOBAL_GO_TO_LISTINGS: ['g', 'v'],
  GLOBAL_GO_TO_FLEET: ['g', 'f'],
  GLOBAL_GO_TO_LEADS: ['g', 'l'],
  GLOBAL_GO_TO_HOTKEYS: 'H',
  GLOBAL_COMMAND_K: 'mod+K',
  GLOBAL_UNFOCUS_OR_CLOSE: 'Escape',
  GLOBAL_TOGGLE_SIDEBAR: 'mod+B',
  HUB_1: 'mod+1',
  HUB_2: 'mod+2',

  // non global
  // UX NOTE: share components should have the same hotkeys so users
  // can use the same hotkey to open the same component in different pages
  DEAL_CDK_ID: 'shift+C',
  DEAL_PRIORITY: 'P',
  DEAL_CONTRACT_STATUS: 'E',
  DEAL_STATUS: 'S',
  DEAL_DELIVERY_PREFERENCE: 'shift+P',
  DEAL_DELIVERY_DATE: 'shift+D',
  DEAL_PICKUP_DATE: 'shift+U',
  DEAL_DELIVERY_QUEUE: 'shift+Q',
  DEAL_SALES_REP_1: 'shift+R',
  DEAL_SALES_REP_2: 'shift+E',
  DEAL_FINANCE_MANAGER: 'shift+F',
  DEAL_CLIPBOARD_LINK: 'mod+shift+L',
  DEAL_CLIPBOARD_CDK_ID: 'mod+shift+C',
  DEAL_CLIPBOARD_VIN: 'mod+shift+I',
  DEAL_GO_TO_NEXT_DEAL: 'J',
  DEAL_GO_TO_PREV_DEAL: 'K',
  DEAL_FAVORITE_UNFAVORITE: 'alt+F',
  DEAL_PRICE_BREAKDOWN_LOCK: 'shift+L',
  DEAL_DEAL_MENU: 'shift+A',
  DEAL_ADD_TASK: 'mod+shift+O',
  DEAL_RAPID_RECON_STEP: 'R',
  DEAL_DELIVERY_STAGE: 'D',
  DEAL_SUBMIT_COMMENT: 'mod+Enter',
  DEAL_FUNDING_METHOD: 'M',
  DEAL_LENDER: 'L',
  DEAL_ADD_PAYMENT: 'mod+shift+P',
  DEAL_UPLOAD_FILE: 'mod+shift+U',
  DEAL_VEHICLE_SWAP: 'mod+shift+V',

  TRADE_IN_1: 'T+1',
  TRADE_IN_2: 'T+2',
  TRADE_IN_3: 'T+3',
  TRADE_ADD: 'T+A',

  FILTERS: 'F',
  FILTERS_TOGGLE_MATCH_ALL_OR_ANY: 'M',
  FILTERS_TOGGLE_MY_DEALS_FILTERS: 'mod+M',

  // Inbox View
  TOGGLE_READ_UNREAD: 'U',
  INBOX_GO_TO_FIRST_NOTIFICATION: 'J',
  INBOX_GO_TO_LAST_NOTIFICATION: 'K',

  // Delete Notification
  DELETE_SINGLE_NOTIFICATION: 'backspace',
  DELETE_ALL_READ_NOTIFICATION: 'shift+backspace',

  // My Deals View
  FIND_IN_VIEW: 'mod+f',
  FIND_IN_VEHICLES: 'mod+f',

  // Payment Dialog
  PAYMENT_DIALOG_SUBMIT: 'mod+Enter',

  // Image Carousel
  IMAGE_CAROUSEL_GO_TO_PREVIOUS: 'left',
  IMAGE_CAROUSEL_GO_TO_NEXT: 'right',
  // IMAGE_CAROUSEL_OPEN_IN_NEW_TAB: 'mod+shift+T',
  IMAGE_CAROUSEL_ROTATE_CLOCKWISE: 'up',
  IMAGE_CAROUSEL_ROTATE_COUNTER_CLOCKWISE: 'down',

  // Vehicle Listings
  VEHICLE_LISTING_STATUS: 'V',
  VEHICLE_LISTING_PURCHASE_STATUS: 'P',
  VEHICLE_LISTING_NUMBER_OF_KEYS: 'N',
  VEHICLE_LISTING_VEHICLE_HISTORY: 'H',
  VEHICLE_LISTING_PREVIOUS_OWNERS: 'O',
  VEHICLE_LISTING_TRANSACTION_TYPE: 'W',
  VEHICLE_BODY_STYLE: 'B',
  VEHICLE_CHARGING_PLUG: 'C',
  VEHICLE_AUTOPILOT: 'A',
  VEHICLE_SEATING_CAPACITY: 'S',
};

export const checkHotkey = ({
  hotkey,
  event,
}: {
  hotkey: string;
  event: KeyboardEvent | KeyboardEvent<HTMLDivElement>;
}) => {
  if (hotkey.includes('mod')) {
    return event.metaKey && event.key === hotkey.split('+')[1];
  }

  return event.key === hotkey;
};
